import React, { useState, useEffect } from "react";
import "./JobDetailsSection.css";
import sampleImage from "../../assets/akinex-placeholder.png";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

const JobDetailsSection = () => {
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { id } = useParams();
  const { jobs } = useSelector((state) => state.data);

  useEffect(() => {
    setJob(jobs.filter(i => i._id === id)[0])
  }, [jobs]);

  // ✅ Function to split long text into bullet points
  const formatTextAsList = (text) => {
    if (!text) return text; // If text is not formatted, return as it is

    // Match only text that starts with numbers like "1. ", "2. ", etc.
    const numberedPattern = /^\d+\.\s+/;
    const points = text.split(/\n|\r/).filter(line => numberedPattern.test(line));

    // If no numbered points are found, return text as-is
    if (points.length === 0) return <p>{text}</p>;

    return (
      <ul>
        {points.map((point, index) => (
          <li key={index}>{point.replace(numberedPattern, "").trim()}</li>
        ))}
      </ul>
    );
  };

  return (
    <section className="jobdesc-details">
      {/* Left Side - Job Details */}
      <div className="whole-job-detail">
        <div className="jobdesc-sections">
          <h2>Job Details</h2>
          <div className="jobdesc-detail-box">
            <p><strong>Position:</strong> {job?.title || "N/A"}</p>
            <p> <strong>Location:</strong> {job?.location || "N/A"}</p>
            <p> <strong>Date Posted:</strong> {job?.createdAt ? new Date(job.createdAt).toLocaleDateString('en-GB') : "N/A"}</p>
          </div>

          {/* ✅ JOB DESCRIPTION SECTION */}
          {job?.description && (
            <div className="jobdesc-section open">
              <h3>Job Description</h3>
              <div className="jobdesc-content">
                <p>{job.description}</p>
              </div>
            </div>
          )}

          {/* ✅ KEY RESPONSIBILITIES */}
          {job?.KeyResponsibilities && (
            <div className="jobdesc-section open">
              <h3>Key Responsibilities</h3>
              <div className="jobdesc-content">
                {formatTextAsList(job.KeyResponsibilities) || "Not specified"}
              </div>
            </div>
          )}

          {/* ✅ REQUIRED COMPETENCIES */}
          {job?.RequiredCompetencies && (
            <div className="jobdesc-section open">
              <h3>Required Competencies</h3>
              <div className="jobdesc-content">
                {formatTextAsList(job.RequiredCompetencies) || "Not specified"}
              </div>
            </div>
          )}

          {/* ✅ DESIRED PROFILE */}
          {job?.DesiredProfile && (
            <div className="jobdesc-section open">
              <h3>Desired Profile</h3>
              <div className="jobdesc-content">
                {/* <p><FaGraduationCap /> <strong>Education:</strong></p> */}
                {formatTextAsList(job.DesiredProfile) || "Not specified"}
              </div>
            </div>
          )}

        {/* ✅ KPIs */}
        {job?.kpi && (
          <div className="jobdesc-section open">
            <h3>Key Performance Indicators (KPIs)</h3>
            <div className="jobdesc-content">
              {formatTextAsList(job.kpi) || "Not specified"}
            </div>
          </div>
        )}

        {/* ✅ PERKS & BENEFITS */}
        {Array.isArray(job?.perks) && job.perks.length > 0 && (
          <div className="jobdesc-section open">
            <h3>Perks & Benefits</h3>
            <div className="jobdesc-content">
              <ul>
                {job.perks.map((perk, index) => (
                  <li key={index}>{perk}</li>
                ))}
              </ul>
            </div>
          </div>
        )}

        {/* Quote Box */}
        <div className="quote-box">
          <p>“A great opportunity awaits, offering exciting challenges and growth. Join us today and become a part of something extraordinary!”</p>
        </div>
        
        <div className="applybutton">
          <button className="jobdetailview-apply-btn" onClick={() => { if (job.jobLink) {  const formattedLink = job.jobLink.startsWith("http") ? job.jobLink : `https://${job.jobLink}`;
        window.open(formattedLink, "_blank");} else {window.open("https://akinex.hoshihrms.com/liberation/103/REQUESTID/aFE9PQ", "_blank") }}}>Apply Now</button>
        </div>
      </div>

      {/* Right Side - Job Image */}
      <div className="jobdesc-image-container">
        <img src={sampleImage} alt="Job" className="jobdesc-image" />
      </div>
      </div>
    </section>
  );
};

export default JobDetailsSection;